import { useState } from "react";

const faqs = [
  {
    q: "予約は当日でも間に合いますか？",
    a: "はい、空き状況によっては試合日当日のご予約・飛び込み予約も承っております。ただし、人気カード（開幕戦・週末・イベント日）は数日前に満車となる場合があるため、お電話（011-375-3226）または公式LINEにてお早めのご確認をおすすめします。【公式LINEでしか獲得出来ないお得サービス実施中です！】",
    link: { text: "公式LINEはこちら", url: "https://lin.ee/v0fi5uo" },
  },
  {
    q: "シャトルバスの運行時間は？",
    a: "試合開始前と試合終了後に運行しています。行きは試合開始に間に合うよう、帰りは試合終了後にお待ちいただくことなく順次運行いたします。",
  },
  {
    q: "雨の日や雪の日でも安心して利用できますか？",
    a: "はい。シャトルは安全運転で運行し、冬道でも安心です。ただし荒天時は運行に時間がかかる場合がございますので、時間に余裕をもってお越しください。",
  },
  {
    q: "支払い方法は何が使えますか？",
    a: "現金、各種カード、ペイペイ、dカードがご利用可いただけます。",
  },
  {
    q: "キャンセルはできますか？",
    a: "ご予定が変わった際は、お電話または公式LINEにてお早めにご連絡ください。試合日前日までのご連絡でキャンセル料は発生しません。",
  },
  {
    q: "大型車・キャンピングカーでも駐車可能ですか？",
    a: "はい、車種を問わず一律料金でご利用いただけます。大型車も駐車可能ですが、事前にお電話かLINEにてお知らせいただけるとスムーズにご案内できます。",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="bg-background-100 py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-5">
            <span className="font-heading italic text-primary-600 text-sm tracking-[0.3em] uppercase">
              FAQ
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-950">
              よくある<br />ご質問
            </h2>
            <p className="mt-5 text-foreground-700 text-sm leading-relaxed">
              初めての方に多くいただくご質問をまとめました。
              その他のご不明点は、お気軽にお問い合わせください。
            </p>
          </div>

          <div className="md:col-span-7 divide-y divide-foreground-950/10">
            {faqs.map((f, i) => {
              const active = open === i;
              return (
                <div key={f.q} className="py-4">
                  <button
                    onClick={() => setOpen(active ? null : i)}
                    className="w-full flex items-center justify-between gap-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg text-foreground-950">
                      {f.q}
                    </span>
                    <span className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
                      active ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-800"
                    }`}>
                      <i className={`ri-${active ? "subtract" : "add"}-line`} />
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      active ? "max-h-64 mt-3" : "max-h-0"
                    }`}
                  >
                    <p className="text-foreground-700 text-sm leading-relaxed pr-12">
                      {f.a}
                    </p>
                    {f.link && (
                      <a
                        href={f.link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-3 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                      >
                        <i className="ri-external-link-line mr-1 align-middle" />
                        {f.link.text}
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}